(function (angular, app) {
    'use strict';

    app.controller('AddToShopListCtrl', [
        '$scope', '$rootScope', 'Dialog', 'ShopListService', 'lines', 'orderId',
        function ($scope, $rootScope, dialog, shopListService, lines, orderId) {
            var addToShopListCtrl = this;

            addToShopListCtrl.createNewList = false;
            addToShopListCtrl.chooseList = chooseList;
            addToShopListCtrl.createList = createList;

            shopListService.get().then(function (res) {
                addToShopListCtrl.shopLists = res.shopLists;
            });

            function chooseList() {
                shopListService.patchItems(addToShopListCtrl.shopList.id, lines, addToShopListCtrl.shopList.name, orderId).then(function () {
                    dialog.hide();
                });
            }

            function createList() {
                shopListService.create(addToShopListCtrl.name, lines, $rootScope.SP_SERVICES.MIXPANEL_VALUES.LIST_ACTION_TYPE.SAVE_TO_EXISTING, orderId).then(function () {
                    dialog.hide();
                });
            }
        }]);
})(angular, app);